{
  "difficulty": {
    "beginner": "Principiante",
    "intermediate": "Intermedio",
    "advanced": "Avanzado"
  },
  "card": {
    "completed": "Completado",
    "courseCount_one": "{{count}} curso",
    "courseCount_zero": "{{count}} cursos",
    "courseCount_other": "{{count}} cursos",
    "progress": "Progreso:",
    "courseOf": "Curso {{current}} de {{total}}",
    "review": "Repasar",
    "continue": "Continuar",
    "startTrail": "Iniciar ruta"
  },
  "roadmap": {
    "trailProgress": "Progreso de la ruta:",
    "coursesCompleted_one": "{{completed}} de {{count}} curso completado",
    "coursesCompleted_zero": "{{completed}} de {{count}} cursos completados",
    "coursesCompleted_other": "{{completed}} de {{count}} cursos completados",
    "required": "Obligatorio",
    "courseProgress": "Progreso del curso:",
    "courseNumber": "Curso {{number}}",
    "startCourse": "Iniciar curso",
    "completedTitle": "🎉 ¡Felicidades! ¡Ruta completada!",
    "completedDescription": "Completaste todos los cursos de esta ruta de aprendizaje."
  },
  "list": {
    "searchPlaceholder": "Buscar rutas...",
    "difficultyPlaceholder": "Dificultad",
    "tagPlaceholder": "Etiqueta",
    "allTags": "Todas las etiquetas",
    "statusPlaceholder": "Estado",
    "sortPlaceholder": "Ordenar",
    "sort": {
      "title": "Título",
      "difficulty": "Dificultad",
      "duration": "Duración",
      "popularity": "Popularidad",
      "progress": "Progreso"
    },
    "filter": {
      "all": "Todas",
      "notStarted": "Sin empezar",
      "inProgress": "En curso",
      "completed": "Completadas"
    },
    "resultsCount_one": "{{count}} ruta encontrada",
    "resultsCount_zero": "{{count}} rutas encontradas",
    "resultsCount_other": "{{count}} rutas encontradas",
    "activeSearch": "Búsqueda: {{value}}",
    "activeDifficulty": "Dificultad: {{value}}",
    "activeTag": "Etiqueta: {{value}}",
    "activeStatus": "Estado: {{value}}",
    "clearFilters": "Limpiar filtros",
    "emptyTitle": "No se encontraron rutas",
    "emptyFiltered": "Intenta ajustar los filtros de búsqueda.",
    "emptyDescription": "No hay rutas disponibles en este momento."
  }
}
